<template>
  <section
    id="about"
    class="hide-overflow"
  >
    <v-layout white>
      <v-flex
        xs12
        md6
        pa-5
      >
        <base-bubble-1
          style="transform: translate(5%, -5%)"
        />
        <base-heading class="info--text">
          {{ $t('whatCanIdo') }}
        </base-heading>

        <base-text class="mb-5">
          {{ $t('learn') }}
        </base-text>

        <base-subheading class="info--text">
          {{ $t('mySkills') }}
        </base-subheading>
        <base-text class="mb-5">
          {{ $t('technologies') }}
        </base-text>

        <v-alert
          outlined
          color="info"
        >
          <v-layout
            v-for="(skill, i) in skills"
            :key="i"
            style="color: #69A1BB;"
            wrap
          >
            <v-flex
              xs6
              text-uppercase
              v-text="skill.name"
            />
            <v-flex
              xs6
              text-xs-right
              v-text="`${skill.value}%`"
            />
            <v-progress-linear
              :value="skill.value"
              color="info"
              height="8"
            />
          </v-layout>
        </v-alert>
      </v-flex>
      <v-flex
        hidden-sm-and-down
        md6
      >
        <v-img
          :src="'https://firebasestorage.googleapis.com/v0/b/testingsystemdls.appspot.com/o/freelance%2Fcode.jpg?alt=media&token=07004d1b-89ec-44b9-bca1-43c79b6b662d'"
          height="100%"
        />
      </v-flex>
    </v-layout>
  </section>
</template>

<script>
export default {
  data: () => ({
    skills: [
      {
        name: 'Php5/7',
        value: 80
      },
      {
        name: 'MySQL',
        value: 85
      },
      {
        name: 'VueJS (study)',
        value: 50
      },
      {
        name: 'YII2',
        value: 80
      },
      {
        name: 'Laravel (study)',
        value: 10
      },
      {
        name: 'HTML',
        value: 80
      },
      {
        name: 'CSS3',
        value: 80
      },
      {
        name: 'JavaScript (study)',
        value: 30
      }
    ]
  })
}
</script>
